export default function PHP_ftp_put() {
  return (
    <div>
      <h1>PHP_ftp_put</h1>
    </div>
  );
}
